// extracted by mini-css-extract-plugin
export var carousel = "homedoctor-module--carousel--5870c";
export var carouselNav = "homedoctor-module--carousel-nav--3bd98";
export var content = "homedoctor-module--content--06b2d";
export var ctas = "homedoctor-module--ctas--640ad";
export var doctorItem = "homedoctor-module--doctor-item--3ef5e";
export var eyebrow = "homedoctor-module--eyebrow--4957e";
export var image = "homedoctor-module--image--e5a77";
export var inner = "homedoctor-module--inner--0d0ef";
export var job = "homedoctor-module--job--8c802";
export var link = "homedoctor-module--link--4b266";
export var name = "homedoctor-module--name--05cf2";
export var title = "homedoctor-module--title--fa4ac";
export var wrap = "homedoctor-module--wrap--8c5cf";